module.exports = __webpack_public_path__ + "static/img/IMG_20150307_154839.7d5e7abb.jpg";